(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["driac-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function extractYouTubeId(url) {
    var match = url.match(
      /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
    );
    return match ? match[1] : null;
  }

  function onOverlayClick(event) {
    var overlay = event.target.closest('[data-driac-video-play]');
    if (!overlay) return;
    var media = overlay.closest('.driac-video__media');
    if (!media) return;

    var youtubeUrl = media.dataset.driacYoutube;
    if (youtubeUrl) {
      var videoId = extractYouTubeId(youtubeUrl);
      if (!videoId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'driac-video__youtube-iframe';
      media.appendChild(iframe);
      overlay.setAttribute('hidden', '');
      var poster = media.querySelector('.driac-video__poster');
      if (poster) poster.setAttribute('hidden', '');
      return;
    }

    var video = media.querySelector('.driac-video__video');
    if (!video) return;
    overlay.setAttribute('hidden', '');
    video.setAttribute('controls', '');
    video.play().catch(function () {});
  }

  document.addEventListener('click', onOverlayClick);
})();

  } catch(e) { console.error(e); }
})();
})();
